import { Typography } from 'seagull';
import styles from "./EmptyState.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const illustrations = {
  invoices: /*#__PURE__*/_jsxs("svg", {
    width: "248",
    height: "248",
    viewBox: "0 0 248 248",
    fill: "none",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "19",
      y: "65",
      width: "144",
      height: "177",
      rx: "8",
      fill: "#F7F4FF"
    }), /*#__PURE__*/_jsx("rect", {
      x: "83",
      y: "17",
      width: "146",
      height: "177",
      rx: "8",
      stroke: "#F3F0FF",
      strokeWidth: "2",
      strokeMiterlimit: "1",
      strokeLinecap: "round",
      strokeDasharray: "8 12"
    }), /*#__PURE__*/_jsx("rect", {
      x: "52",
      y: "42",
      width: "144",
      height: "175",
      rx: "7",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M122.5 176V171.875C122.5 171.116 123.172 170.5 124 170.5C124.828 170.5 125.5 171.116 125.5 171.875V176H131.5C132.328 176 133 176.616 133 177.375C133 178.134 132.328 178.75 131.5 178.75H125.5V185.625H127.75C131.478 185.625 134.5 188.395 134.5 191.812C134.5 195.23 131.478 198 127.75 198H125.5V202.125C125.5 202.884 124.828 203.5 124 203.5C123.172 203.5 122.5 202.884 122.5 202.125V198H115C114.172 198 113.5 197.384 113.5 196.625C113.5 195.866 114.172 195.25 115 195.25H122.5V188.375H120.25C116.522 188.375 113.5 185.605 113.5 182.188C113.5 178.77 116.522 176 120.25 176H122.5ZM122.5 178.75H120.25C118.179 178.75 116.5 180.289 116.5 182.188C116.5 184.086 118.179 185.625 120.25 185.625H122.5V178.75ZM125.5 188.375V195.25H127.75C129.821 195.25 131.5 193.711 131.5 191.812C131.5 189.914 129.821 188.375 127.75 188.375H125.5Z",
      fill: "#462DA0"
    }), /*#__PURE__*/_jsx("rect", {
      x: "139",
      y: "95",
      width: "43",
      height: "53",
      rx: "7",
      stroke: "#E3E5E8",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "68",
      y: "95",
      width: "62",
      height: "11",
      rx: "3",
      stroke: "#E3E5E8",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "68",
      y: "116",
      width: "62",
      height: "11",
      rx: "3",
      stroke: "#E3E5E8",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "68",
      y: "137",
      width: "62",
      height: "11",
      rx: "3",
      stroke: "#E3E5E8",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "124",
      cy: "69",
      r: "12",
      fill: "#E3DBFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M68.5 159C67.9477 159 67.5 159.448 67.5 160C67.5 160.552 67.9477 161 68.5 161V159ZM181.5 161C182.052 161 182.5 160.552 182.5 160C182.5 159.448 182.052 159 181.5 159V161ZM68.5 161H181.5V159H68.5V161Z",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("rect", {
      x: "52",
      y: "42",
      width: "144",
      height: "175",
      rx: "7",
      stroke: "#212121",
      strokeWidth: "2"
    })]
  }),
  UpcomingBill: /*#__PURE__*/_jsxs("svg", {
    width: "272",
    height: "248",
    viewBox: "0 0 272 248",
    fill: "none",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "53",
      y: "49",
      width: "166",
      height: "144",
      rx: "8",
      fill: "#F3F0FF"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "69",
      width: "113",
      height: "32",
      rx: "8",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M152 85H184",
      stroke: "#E3E5E8",
      strokeWidth: "4",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M204 83C202.895 83 202 83.8954 202 85C202 86.1046 202.895 87 204 87V83ZM212 87C213.105 87 214 86.1046 214 85C214 83.8954 213.105 83 212 83V87ZM204 87H212V83H204V87Z",
      fill: "#E3E5E8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M224 83C222.895 83 222 83.8954 222 85C222 86.1046 222.895 87 224 87V83ZM232 87C233.105 87 234 86.1046 234 85C234 83.8954 233.105 83 232 83V87ZM224 87H232V83H224V87Z",
      fill: "#E3E5E8"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "69",
      width: "113",
      height: "32",
      rx: "8",
      stroke: "#C7BBF1",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "109",
      width: "113",
      height: "32",
      rx: "8",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M152 125H176",
      stroke: "#E3E5E8",
      strokeWidth: "4",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M204 123C202.895 123 202 123.895 202 125C202 126.105 202.895 127 204 127V123ZM212 127C213.105 127 214 126.105 214 125C214 123.895 213.105 123 212 123V127ZM204 127H212V123H204V127Z",
      fill: "#E3E5E8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M224 123C222.895 123 222 123.895 222 125C222 126.105 222.895 127 224 127V123ZM232 127C233.105 127 234 126.105 234 125C234 123.895 233.105 123 232 123V127ZM224 127H232V123H224V127Z",
      fill: "#E3E5E8"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "109",
      width: "113",
      height: "32",
      rx: "8",
      stroke: "#C7BBF1",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "149",
      width: "113",
      height: "32",
      rx: "8",
      fill: "white",
      fillOpacity: "0.5"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M197.667 164.333H193.667V160.333C193.667 159.965 193.368 159.667 193 159.667C192.632 159.667 192.333 159.965 192.333 160.333V164.333H188.333C187.965 164.333 187.667 164.632 187.667 165C187.667 165.368 187.965 165.667 188.333 165.667H192.333V169.667C192.333 170.035 192.632 170.333 193 170.333C193.368 170.333 193.667 170.035 193.667 169.667V165.667H197.667C198.035 165.667 198.333 165.368 198.333 165C198.333 164.632 198.035 164.333 197.667 164.333Z",
      fill: "#212121"
    }), /*#__PURE__*/_jsx("rect", {
      x: "136",
      y: "149",
      width: "113",
      height: "32",
      rx: "8",
      stroke: "#212121",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeDasharray: "4 8"
    }), /*#__PURE__*/_jsx("rect", {
      x: "33",
      y: "87",
      width: "86",
      height: "70",
      rx: "7",
      fill: "white",
      stroke: "#646569",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 114.41H119",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 129H119",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 143.59H119",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M85.2733 102L85.2733 156",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M102.586 102L102.586 156",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M66.8276 102L66.8276 156",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M49.515 102L49.515 156",
      stroke: "#E3E5E8",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 94C33 90.134 36.134 87 40 87H112C115.866 87 119 90.134 119 94V101H33V94Z",
      fill: "#E3E5E8",
      stroke: "#646569",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "33",
      y: "87",
      width: "86",
      height: "70",
      rx: "7",
      stroke: "#646569",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M50 83V91",
      stroke: "#646569",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M85 83V91",
      stroke: "#646569",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M67 83V91",
      stroke: "#646569",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M102 83V91",
      stroke: "#646569",
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  })
};
export default function EmptyState(props) {
  const {
    title,
    illustration,
    paragraphs,
    testId
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": testId,
    children: [illustrations[illustration], title && /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      weight: "normal",
      children: title
    }), paragraphs.map((paragraph, idx) => /*#__PURE__*/_jsx(Typography, {
      children: paragraph
    }, idx))]
  });
}